import {EntityType} from "../gd/const/item";


export function decodeRID(rid:RID) {

    let entityType  :EntityType
    let entityId    :ID

    const splitRes = rid.split("-")
    entityId    = splitRes[1]

    switch (splitRes[0]) {
        case 'p':
            entityType  = EntityType.PROJECT; break

        case 'g':
            entityType  = EntityType.GOAL; break

        case 'exp':
            entityType  = EntityType.EXPENSE; break

        default:
            console.error("can't decode rid - unknown entoty type prefix", splitRes[0])
            entityType  = EntityType.DYNAMIC_MODEL
    }

    return {entityType, entityId}
}

export function encodeRID(entityType:EntityType, id:ID) {

    switch (entityType) {
        case EntityType.TASK              : return "t-"+id
        case EntityType.PROJECT           : return "p-"+id
        case EntityType.TASK_MESSAGE      : return "tm-"+id
        case EntityType.PROJECT_USER      : return "pu-"+id
        case EntityType.COMPANY_USER      : return "cu-"+id
        case EntityType.CRM_CONTACT       : return "crmc-"+id
        case EntityType.CRM_ACCOUNT       : return "crma-"+id
        case EntityType.EXPENSE           : return "exp-"+id
        case EntityType.AUTOMATION        : return "aut-"+id
        case EntityType.CHAT              : return "chat-"+id
        case EntityType.DOCUMENT          : return "d-"+id
        case EntityType.EVENT             : return "e-"+id
        case EntityType.TIME_REPORT       : return "tr-"+id
        case EntityType.UPDATE_TASK       : return "updt-"+id
        case EntityType.UPDATE_PROJECT    : return "updp-"+id
        case EntityType.STATUS            : return "s-"+id
        case EntityType.DEPENDENCY        : return "dep-"+id
        case EntityType.HISTORY           : return "h-"+id
        case EntityType.MEETING           : return "mee-"+id
        case EntityType.GOAL              : return "g-"+id

        case EntityType.DYNAMIC_MODEL     :
        default                           :
            return "dynamic-"+id
    }
}
